import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var learnerDashboardRes;
export const learnerDashboardTodo = createAsyncThunk('learnerDashboard', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner_dashboard',
            data: {
                "user_id": val,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return learnerDashboardRes = res.data
    } catch (error) {
        return learnerDashboardRes = error.response.data
    }
})


const learnerDashboardSlice = createSlice({
    name: 'learnerDashboard',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(learnerDashboardTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('learnerDashboard', state.data)
            }
        });
        builder.addCase(learnerDashboardTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default learnerDashboardSlice.reducer; 